import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sidebarModules } from '../mockData';
import {
  LayoutDashboard, CreditCard, Users, ShieldCheck,
  FolderOpen, CalendarDays, BarChart3, Settings, Building2, Euro, Package, HardDrive, FileText, Calculator
} from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const iconMap = {
  LayoutDashboard, CreditCard, Users, ShieldCheck,
  FolderOpen, CalendarDays, BarChart3, Building2, Euro, Package, HardDrive, FileText, Calculator
};

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const Sidebar = () => {
  const location = useLocation();
  
  // Get user role to filter menu items
  let userRole = 'admin';
  try {
    const auth = localStorage.getItem('colabella_auth');
    if (auth) userRole = JSON.parse(auth).role || 'admin';
  } catch {}
  
  const hiddenForOperaio = ['paga', 'analisi', 'fatture', 'reportistica'];
  const visibleModules = userRole === 'operaio' ? sidebarModules.filter(m => !hiddenForOperaio.includes(m.id)) : sidebarModules;

  return (
    <TooltipProvider delayDuration={200}>
      <aside className="sidebar">
        {/* Logo */}
        <Link to="/" className="sidebar-logo">
          <img src={LOGO_URL} alt="CG" className="sidebar-logo-img" />
        </Link>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <div className="sidebar-group">
            {visibleModules.map((item) => {
              const IconComp = iconMap[item.icon];
              const isActive = location.pathname === item.path ||
                (item.path !== '/' && location.pathname.startsWith(item.path));
              return (
                <Tooltip key={item.id}>
                  <TooltipTrigger asChild>
                    <Link
                      to={item.path}
                      className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''}`}
                    >
                      {IconComp && <IconComp size={20} strokeWidth={1.8} />}
                    </Link>
                  </TooltipTrigger>
                  <TooltipContent side="right" sideOffset={8}>
                    <p>{item.label}</p>
                  </TooltipContent>
                </Tooltip>
              );
            })}
          </div>
        </nav>

        {/* Bottom */}
        <div className="sidebar-bottom">
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="sidebar-item">
                <Settings size={20} strokeWidth={1.8} />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right" sideOffset={8}>
              <p>Impostazioni</p>
            </TooltipContent>
          </Tooltip>
        </div>
      </aside>
    </TooltipProvider>
  );
};

export default Sidebar;
